export function blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve((reader.result as string).split(',')[1]));
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}
